import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=3940b018&scoped=true"
import script from "./Country.vue?vue&type=script&lang=js"
export * from "./Country.vue?vue&type=script&lang=js"
import style0 from "./Country.vue?vue&type=style&index=0&id=3940b018&prod&lang=scss&scoped=true"
import style1 from "./Country.vue?vue&type=style&index=1&id=3940b018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3940b018",
  null
  
)

export default component.exports